exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--5-1!../../../node_modules/postcss-loader/index.js??postcss!@angular/material/prebuilt-themes/deeppurple-amber.css"), "");

// module
exports.push([module.id, "html, body {\r\n  max-width: 100%;\r\n}\r\n\r\n.grey-background {\r\n  background-color: rgb(94,111,125);\r\n  padding: 0;\r\n  border-radius: 0;\r\n  width: 100%;\r\n  color:grey;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: rgb(94,111,125);\r\n  border-color: rgb(94,120,125);\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: rgb(94,120,145);\r\n  border-color: rgb(94,120,145);\r\n}\r\n\r\n.btn-primary:active {\r\n  background-color: rgb(94,111,125);\r\n  border-color: rgb(94,120,125);\r\n}\r\n\r\n\r\n.navbar-nav {\r\n  width: 100%;\r\n}\r\n\r\n.btn {\r\n  border-radius: 0;\r\n}\r\n\r\n.nav-item {\r\n  width: 25%;\r\n}\r\n\r\n.navbar-button {\r\n  color: white;\r\n  width: 100%;\r\n}\r\n\r\n.navbar-button:hover {\r\n  color: white;\r\n    background-color: rgb(94,120,145);\r\n}\r\n\r\n.navbar-button:focus {\r\n  outline: 0;\r\n  box-shadow: inset 0 0 0 1rem rgb(94,120,145);\r\n}\r\n\r\n.active {\r\n  color: white;\r\n    background-color: rgb(94,120,145);\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/App/app.component.css
// module id = ./src/app/App/app.component.css
// module chunks = 1